import { getQuestionType } from '@exam-management/common/utils';
import { TagCategory } from '@exam-management/graphql';
import {
  DEFAULT_CRITERIA,
  DifficultyText,
  getDifficultyCriteria,
} from '@exam-management/qcontent-management';
import { Box, Flex, ReadonlyField, SectionTitle, Text } from '@shared/components';

import { useQuestionReviewTaskQuestionDetails } from '../../providers';

function NoInformationText() {
  return <Text color='textDisabled'>ยังไม่มีข้อมูล</Text>;
}

export default function QuestionInformationView() {
  const { question } = useQuestionReviewTaskQuestionDetails();
  const calculation = question.tags.find((tag) => tag.category === TagCategory.Calculation);
  const currentCriteria = getDifficultyCriteria(DEFAULT_CRITERIA, question.pValue);
  const questionType = getQuestionType(question.questionGroup?.type);

  const isItemSet = questionType === 'item-set';

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(4) })}>
      <SectionTitle title='Information' />
      <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(4) })}>
        {isItemSet ? (
          <ReadonlyField
            label='Item Set Name'
            content={<Text>{question.questionGroup?.name}</Text>}
          />
        ) : null}
        <Flex sx={(theme) => ({ gap: theme.spacing(6) })}>
          <Box sx={{ flex: 1 }}>
            <ReadonlyField
              label='ประเภทข้อสอบ'
              content={
                <Text color={calculation?.name ? 'textPrimary' : 'textDisabled'}>
                  {calculation?.name ?? 'ยังไม่มีข้อมูล'}
                </Text>
              }
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <ReadonlyField
              label='ค่า P Initial'
              content={
                typeof question.pValue === 'number' ? (
                  <Flex sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <Text>{question.pValue}</Text>
                    <DifficultyText criteria={currentCriteria} />
                  </Flex>
                ) : (
                  <NoInformationText />
                )
              }
            />
          </Box>
        </Flex>
      </Flex>
    </Flex>
  );
}
